
const SlideArrow = () => {
    return (
        <img alt="" src={require('src/assets/images/homev1/slide-point.png')} width={8} className="iconarrow" />
    )
}

export default SlideArrow;
